 enum Paths {
    DASHBOARD = '/dashboard',
    DASHBOARD_V2 = '/dashboard-v2',
    ROLES = '/roles/list',
    ROOMS_CLIENTS = '/rooms/list',
    CLIENTS = '/clients/list',
    CLIENT_PAGE = '/clients/:id',
    
    USERS = '/users/list',
    USERS_ADD = '/users/add',
    USERS_EDIT = '/users/edit/:id',
    USERS_ACTIVITY = '/users/activity/:id',

    VAT = '/vat/list',
    PRODUCT_ATTRIBUTES = '/productAttributes/list',
    
    PRODUCT_ATTRIBUTE_PAGE = '/productAttribute/:id',
    
    ORDER_PAGE = '/orders/:id',
    ORDERS = '/orders/list',

    CLIENT_TYPES = '/clientTypes/list',

    CATEGORIES = '/categories/list',
    
    PRODUCTS = '/products/list',
    PRODUCTS_ADD = '/products/add',
    PRODUCTS_EDIT = '/products/edit/:id',


    GAMES = '/games/list',
    GAMES_EDIT = '/games/edit/:id',


    GENERAL_SETTINGS_EDIT = '/home-highlights/edit/:id',
    HOME_HIGHLIGHTS_V2_EDIT = '/home-highlights-v2/edit/:id',
    PLAYERS_OF_PERIOD_EDIT = '/players-of-period/edit/:id',
    REWARD_SETTINGS_EDIT = '/generalSettings/edit/:id',
    
    NOTIFICATIONS_ADD = '/notifications/add',

    COUPONS = '/coupons/list',
    COUPONS_EXPIRED = '/coupons/expired/list',
    COUPONS_EDIT = '/coupons/edit/:id',
    POINTS = '/points/list',
    TOURNAMENTS = '/tournaments/list',
    TOURNAMENTS_ADD = '/tournaments/add',
    TOURNAMENTS_EDIT = '/tournaments/edit/:id',
    TOURNAMENT_POINTS = '/tournament-points/list',
    SPONSORS = '/sponsors/list',
    SPONSORS_ADD = '/sponsors/add',
    SPONSORS_EDIT = '/sponsors/edit/:id',

    FAQ = '/faq/list',
    FAQ_ADD = '/faq/add',
    FAQ_EDIT = '/faq/edit/:id',

    CONTACT_FORM_REQUESTS = '/contact-forms/list',
    REPORT_ISSUE_REQUESTS = '/report-issues/list',
    
    LEAGUES = '/leagues/list',
    LEAGUES_ADD = '/leagues/add',
    LEAGUES_EDIT = '/leagues/edit/:id',

    MARKETS = '/markets/list',
    MARKETS_ADD = '/markets/add',
    MARKETS_EDIT = '/markets/edit/:id',

    TEXT_CONSTANTS = '/textConstats/list',
    TEXT_CONSTANTS_ADD = '/textConstats/add',
    TEXT_CONSTANTS_EDIT = '/textConstats/edit/:id',

    
    
    TEAMS = '/teams/list',
    TEAMS_ADD = '/teams/add',
    TEAMS_EDIT = '/teams/edit/:id',

    MISSIONS = '/missions/list',
    MISSIONS_ADD = '/missions/add/',
    MISSIONS_EDIT = '/missions/edit/:id',

    TRANSACTIONS = '/transactions/list',
    TRANSACTIONS_ADD = '/transactions/add/',
    TRANSACTIONS_EDIT = '/transactions/edit/:id',

    COUNTRIES = '/country/list',
    COUNTRIES_ADD = '/country/add',
    COUNTRIES_EDIT = '/country/edit/:id',

    BETTING_COMPANIES = '/betting-companies/list',
    BETTING_COMPANIES_ADD = '/betting-companies/add',
    BETTING_COMPANIES_EDIT = '/betting-companies/edit/:id',

    SIGN_IN = '/sign-in',

    LEAGUES_ORDER_PAGE = '/leagues/order',
    

    CLIENTS_COMMISSIONS = '/clientsCommissions/list',
    CLIENT_COMMISSIONS = '/clientCommissions/list',

     PURCHASES = '/purchases/list',
     MONITORING = '/monitoring',
     GOAL_TIMING = '/goal-timing',
}
enum Names {
    DASHBOARD = 'dashboard',
    DASHBOARD_V2 = 'dashboardV2',

   
    CLIENTS = 'clientsList',
    CLIENT_PAGE = 'clientPage',
    
    USERS = 'usersList',
    USERS_ADD = 'usersAdd',
    USERS_EDIT = 'usersEdit',
    USERS_ACTIVITY = 'usersActivity',


    CATEGORIES = 'categoriesList',
    
    LEAGUES = 'leaguesList',
    LEAGUES_ADD = 'leaguesAdd',
    LEAGUES_EDIT = 'leaguesEdit',

    MARKETS = 'marketsList',
    MARKETS_ADD = 'marketsAdd',
    MARKETS_EDIT = 'marketsEdit',

    TEXT_CONSTANTS = 'textConstatsList',
    TEXT_CONSTANTS_ADD = 'textConstatsAdd',
    TEXT_CONSTANTS_EDIT = 'textConstatsEdit',

    TEAMS = 'teamsList',
    TEAMS_ADD = 'teamsAdd',
    TEAMS_EDIT = 'teamsEdit',

    GAMES = 'gamesList',
    
    MISSIONS = 'missionslist',
    MISSIONS_EDIT = 'missionsEdit',
    MISSIONS_ADD = 'missionsAdd',

    TRANSACTIONS = 'transactionslist',
    TRANSACTIONS_EDIT = 'transactionsEdit',
    TRANSACTIONS_ADD = 'transactionsAdd',

    GAMES_EDIT = 'gamesEdit',

    GENERAL_SETTINGS_EDIT = 'generalSettingsSettings',
    HOME_HIGHLIGHTS_V2_EDIT = 'homeHighlightsV2Settings',
    PLAYERS_OF_PERIOD_EDIT = 'playersOfPeriodSettings',
    REWARD_SETTINGS_EDIT = 'rewardSettingsSettings',

    NOTIFICATIONS_ADD = 'notificationsAdd',
    

    COUPONS = 'couponsList',
    COUPONS_EXPIRED = 'couponsExpiredList',
    COUPONS_EDIT = 'couponsEdit',
    POINTS = 'pointsList',
    TOURNAMENTS = 'tournamentsList',
    TOURNAMENTS_ADD = 'tournamentsAdd',
    TOURNAMENTS_EDIT = 'tournamentsEdit',
    TOURNAMENT_POINTS = 'tournamentPointsList',
    SPONSORS = 'sponsorsList',
    SPONSORS_ADD = 'sponsorsAdd',
    SPONSORS_EDIT = 'sponsorsEdit',

    FAQ = 'faqList',
    FAQ_ADD = 'faqAdd',
    FAQ_EDIT = 'faqEdit',

    CONTACT_FORM_REQUESTS = 'contactFormRequests',
    REPORT_ISSUE_REQUESTS = 'reportIssueRequests',
    
    COUNTRIES = 'countriesList',
    COUNTRIES_ADD = 'countriesAdd',
    COUNTRIES_EDIT = 'countriesEdit',

    BETTING_COMPANIES = 'bettingCompaniesList',
    BETTING_COMPANIES_ADD = 'bettingCompaniesAdd',
    BETTING_COMPANIES_EDIT = 'bettingCompaniesEdit',

    SIGN_IN = 'sign-in',

    LEAGUES_ORDER_PAGE = 'leaguesOrderPage',

    PURCHASES = 'purchasesList',
    MONITORING = 'monitoring',
    GOAL_TIMING = 'goalTiming',
}
export {Names,Paths}
